import { combineReducers } from 'redux';

import appReducer, { AppState } from './app/app';
import authenticationReducer, { AuthenticationState } from './authentication/authentication';
import candidateReducer, { CandidateState } from './candidate/candidate';
import candidateExchangeReducer, { CandidateExchangeState } from './candidateExchange/candidateExchange';
import candidateInviteReducer, { CandidateInviteState } from './candidateInvite/candidateInvite';
import candidateOverviewReducer, { CandidateOverviewState } from './candidateOverview/candidateOverview';
import candidateRelationsReducer, { CandidateRelationsState } from './candidateRelations/candidateRelations';
import coachingAdviceReducer, { CoachingAdviceState } from './coachingAdvice/coachingAdvice';
import competenciesReducer, { CompetenciesState } from './competencies/competencies';
import competentNLReducer, { CompetentNLState } from './competentNL/competentNL';
import counselorReducer, { CounselorState } from './counselor/counselor';
import counselorOptionsReducer, { CounselorOptionsState } from './counselorOptions/counselorOptions';
import counselorOverviewReducer, { CounselorOverviewState } from './counselorOverview/counselorOverview';
import developmentOverviewReducer, { DevelopmentOverviewState } from './developmentOverview/developmentOverview';
import developmentPlanReducer, { DevelopmentPlanState } from './developmentPlan/developmentPlan';
import developmentPlanCompetencyReducer, { DevelopmentPlanCompetencyState } from './developmentPlanCompetency/developmentPlanCompetency';
import developmentPlanEvaluationReducer, { DevelopmentPlanEvaluationState } from './developmentPlanEvaluation/developmentPlanEvaluation';
import developmentPlanPrivateNotesReducer, { DevelopmentPlanPrivateNotesState } from './developmentPlanPrivateNotes/developmentPlanPrivateNotes';
import developmentPlanPublicNotesReducer, { DevelopmentPlanPublicNotesState } from './developmentPlanPublicNotes/developmentPlanPublicNotes';
import developmentPlanSkillReducer, { DevelopmentPlanSkillState } from './developmentPlanSkill/developmentPlanSkill';
import educationsReducer, { EducationsState } from './educations/educations';
import internalOccupationDetailReducer, { InternalOccupationDetailState } from './internalOccupationDetail/internalOccupationDetail';
import internalOccupationOverviewReducer, { InternalOccupationOverviewState } from './internalOccupationOverview/internalOccupationOverview';
import jobExperienceReducer, { JobExperienceState } from './jobExperience/jobExperience';
import modulesReducer, { ModulesState } from './modules/modules';
import occupationDetailReducer, { OccupationDetailState } from './occupationDetail/occupationDetail';
import occupationOverviewReducer, { OccupationOverviewState } from './occupationOverview/occupationOverview';
import organisationReducer, { OrganisationState } from './organisation/organisation';
import organisationOccupationReducer, { OrganisationOccupationState } from './organisationOccupation/organisationOccupation';
import organisationOccupationOverviewReducer, { OrganisationOccupationOverviewState } from './organisationOccupationOverview/organisationOccupationOverview';
import organisationOverviewReducer, { OrganisationOverviewState } from './organisationOverview/organisationOverview';
import residencesReducer, { ResidencesState } from './residences/residences';
import schoolExperienceReducer, { SchoolExperienceState } from './schoolExperience/schoolExperience';
import skillsReducer, { SkillsState } from './skills/skills';
import skillsPassportReducer, { SkillsPassportState } from './skillsPassport/skillsPassport';
import tmaAnalysisSettingsReducer, { TmaAnalysisSettingsState } from './tmaAnalysisSettings/tmaAnalysisSettings';
import userReducer, { UserState } from './user/user';

export interface Reducers {
    appReducer: AppState;
    authenticationReducer: AuthenticationState;
    candidateReducer: CandidateState;
    candidateExchangeReducer: CandidateExchangeState;
    candidateInviteReducer: CandidateInviteState;
    candidateOverviewReducer: CandidateOverviewState;
    candidateRelationsReducer: CandidateRelationsState;
    coachingAdviceReducer: CoachingAdviceState;
    competenciesReducer: CompetenciesState;
    competentNLReducer: CompetentNLState;
    counselorReducer: CounselorState;
    counselorOptionsReducer: CounselorOptionsState;
    counselorOverviewReducer: CounselorOverviewState;
    developmentOverviewReducer: DevelopmentOverviewState;
    developmentPlanReducer: DevelopmentPlanState;
    developmentPlanCompetencyReducer: DevelopmentPlanCompetencyState;
    developmentPlanEvaluationReducer: DevelopmentPlanEvaluationState;
    developmentPlanPrivateNotesReducer: DevelopmentPlanPrivateNotesState;
    developmentPlanPublicNotesReducer: DevelopmentPlanPublicNotesState;
    developmentPlanSkillReducer: DevelopmentPlanSkillState;
    educationsReducer: EducationsState;
    internalOccupationOverviewReducer: InternalOccupationOverviewState;
    internalOccupationDetailReducer: InternalOccupationDetailState;
    jobExperienceReducer: JobExperienceState;
    modulesReducer: ModulesState;
    occupationDetailReducer: OccupationDetailState;
    occupationOverviewReducer: OccupationOverviewState;
    organisationReducer: OrganisationState;
    organisationOccupationReducer: OrganisationOccupationState;
    organisationOccupationOverviewReducer: OrganisationOccupationOverviewState;
    organisationOverviewReducer: OrganisationOverviewState;
    residencesReducer: ResidencesState;
    schoolExperienceReducer: SchoolExperienceState;
    skillsReducer: SkillsState;
    skillsPassportReducer: SkillsPassportState;
    tmaAnalysisSettingsReducer: TmaAnalysisSettingsState;
    userReducer: UserState;
}

export default combineReducers({
    appReducer,
    authenticationReducer,
    candidateReducer,
    candidateExchangeReducer,
    candidateInviteReducer,
    candidateOverviewReducer,
    candidateRelationsReducer,
    coachingAdviceReducer,
    competenciesReducer,
    competentNLReducer,
    counselorReducer,
    counselorOptionsReducer,
    counselorOverviewReducer,
    developmentOverviewReducer,
    developmentPlanReducer,
    developmentPlanCompetencyReducer,
    developmentPlanEvaluationReducer,
    developmentPlanPrivateNotesReducer,
    developmentPlanPublicNotesReducer,
    developmentPlanSkillReducer,
    educationsReducer,
    internalOccupationDetailReducer,
    internalOccupationOverviewReducer,
    jobExperienceReducer,
    modulesReducer,
    occupationDetailReducer,
    occupationOverviewReducer,
    organisationReducer,
    organisationOccupationReducer,
    organisationOccupationOverviewReducer,
    organisationOverviewReducer,
    residencesReducer,
    schoolExperienceReducer,
    skillsReducer,
    skillsPassportReducer,
    tmaAnalysisSettingsReducer,
    userReducer,
});
